import Star from "@/assets/svg/advisor-inner/star.svg?react"

interface AdvisorCommentProps {
  name: string
  text: string
}

/** Single review card (text + author + 5-star rating). Ported from AdvisorsInner Comment. */
export function AdvisorComment({ name, text }: AdvisorCommentProps) {
  return (
    <div data-slot="advisor-comment" className="rounded-2xl border border-purple-light/20 p-4">
      <p className="select-none text-left font-body text-base text-purple-light/70">{text}</p>
      <div className="flex flex-col items-start">
        <p className="mt-4 select-none font-display text-base font-medium text-purple-light">
          {name}
        </p>
        <div className="flex items-center gap-1">
          <div className="flex items-center [&_svg]:size-4">
            {Array.from({ length: 5 }).map((_, index) => (
              <Star key={index} />
            ))}
          </div>
          <span className="font-body text-sm font-medium text-gold">5.0</span>
        </div>
      </div>
    </div>
  )
}
